exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rangeslider-horizontal .rangeslider__fill{background-color:#234dd0}.inline-input{background-color:#f7f7f7 !important;font-size:.95rem}.inline-input>div>label{font-weight:600;font-size:.8rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/quote/project/details.scss
// module id = 5873
// module chunks = 0